import React from 'react';
import QueueItem from './QueueItem';
import { imageRegex } from '@utils/regex';
import { ExtendedFile } from '../DropzoneProvider';

interface Props {
  chatRoomId: string;
  files: ExtendedFile[];
}

const ChatMessageUploadQueuePresenter = ({ chatRoomId, files }: Props) => {
  return (
    <div className="queue-container">
      {files.map((file, i) => {
        const isImage = imageRegex.test(
          file.originalFile.name.toLocaleLowerCase()
        )
          ? true
          : false;

        return (
          <QueueItem
            key={i}
            chatRoomId={chatRoomId}
            fileId={file.fileId}
            file={file.originalFile}
            isImage={isImage}
          />
        );
      })}
    </div>
  );
};

export default ChatMessageUploadQueuePresenter;
